import { render, staticRenderFns } from "./DetalleCard.vue?vue&type=template&id=3f898f05&"
import script from "./DetalleCard.vue?vue&type=script&lang=js&"
export * from "./DetalleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports